import { Pipe, PipeTransform } from "@angular/core";
import { TaskViewModel } from "../../admin-panel/Tasks/Model/TaskViewModel";
import { GroupFilterModel } from "./FilterByNameAndGroup.pipe";


@Pipe({
    name: 'tasksFilter',
    pure: false,
    standalone: false
})
export class FilterTasksPipe implements PipeTransform
{
  transform(items: TaskViewModel[], filter: GroupFilterModel): any
  {
    if (!items) return [];

    if (filter.term && filter.term != "") {
      var filteredItems = [];
      let lowerCaseTerm = filter.term.toLowerCase();
      for (let i = 0; i < items.length; i++)
        if (items[i].Tracker.Name.toLowerCase().indexOf(lowerCaseTerm) >= 0)
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;

      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0) {
      let groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      var filteredItems = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].TrackerId])
          filteredItems.push(items[i]);
        //else
          //items[i].IsChecked = false;
      return filteredItems;
    }
    return items;
  }
}
